<template>
  <div style="padding: 15px" class="bg-white" v-loading="isLoading">
    <el-row v-if="!is_disabled" :gutter="15">
      <el-col :sm="12">
        <label>Customer</label>
        <el-select :disabled="is_disabled" v-model="customer" filterable @change="getTableData">
          <el-option
            v-for="(c, index) in customers"
            :key="index"
            :value="c.id"
            :label="c.name"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :sm="12">
        <label>ULD Type</label>
        <el-select v-model="uldType" filterable multiple placeholder="ALL">
          <el-option
            v-for="(s, index) in uldTypes"
            :key="index"
            :value="s.description"
            :label="s.description"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row v-if="!is_disabled" class="mt-1">
      <el-col>
        <el-button type="primary" @click="getTableData"
          >Get Completed Job Orders</el-button
        >
        <el-button
          :disabled="selection.length == 0"
          type="success"
          @click="createNote"
          >Create Delivery Note</el-button
        >
        <el-button
          :disabled="selection.length == 0"
          type="success"
          @click="addToBatch"
          >Add to Existing Batch</el-button
        >
      </el-col>
    </el-row>
    <el-row class="mt-2">
      <el-table
        row-key="temp"
        border
        :data="tableData"
        default-expand-all
        @selection-change="updateSelection"
      >
        <el-table-column min-width="130" label="" prop="label">
        </el-table-column>
        <el-table-column label="ID Code" prop="uld_id_code"></el-table-column>
        <el-table-column
          label="Manufacturer"
          prop="manufacturer_name"
        ></el-table-column>
        <el-table-column v-if="!is_disabled" label="JO Number">
          <template slot-scope="scope">
            <a
              :href="`/repair/repair-uld/info/${scope.row.id}`"
              target="_blank"
              >{{ scope.row.job_order_number }}</a
            >
          </template>
        </el-table-column>
        <el-table-column label="Date Received">
          <template slot-scope="scope">
            <span v-if="scope.row.date_received">{{
              scope.row.date_received | dateFormat("LL")
            }}</span></template
          >
        </el-table-column>
        <el-table-column label="Date Completed" prop="job_completed">
          <template slot-scope="scope">
            <span v-if="scope.row.job_completed">{{
              scope.row.job_completed | dateFormat("LL")
            }}</span></template
          >
        </el-table-column>
        <el-table-column
          width="90px"
          label="Deliver?"
          type="selection"
          :selectable="verifySelection"
          v-if="!is_disabled"
        >
        </el-table-column>
      </el-table>
    </el-row>
    <app-dialog ref="dialog" v-loading="isLoading">
      <el-form
        ref="form"
        :model="formModel"
        label-position="top"
        :rules="rules"
      >
        <el-alert
          show-icon
          id="top-alert"
          type="info"
          :closable="false"
          effect="dark"
        >
          Delivery number will generate once submitted.
        </el-alert>
        <el-form-item label="Delivery Date" prop="delivery_date">
          <el-date-picker
            type="date"
            v-model="formModel.delivery_date"
          ></el-date-picker>
        </el-form-item>
        <!-- <el-form-item prop="is_jettainer">
          <el-checkbox v-model="formModel.is_jettainer"
            >Is Jettainer</el-checkbox
          >
        </el-form-item> -->
      </el-form>
      <template v-slot:footer>
        <el-button type="primary" @click="save" :disabled="isLoading"
          >Save</el-button
        >
      </template>
    </app-dialog>
    <app-dialog ref="addToUld" :preventClose="isLoading">
      <el-form
        :model="uldOut"
        :rules="{ id: [{ required: true, message: 'ULD Out is required.' }] }"
      >
        <el-form-item label="Choose ULD Out Batch" prop="id">
          <el-select v-model="uldOut.id" filterable clearable>
            <el-option
              v-for="item in uldOutList"
              :key="item.id"
              :label="item.batch_no"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <template v-slot:footer>
        <el-button type="primary" @click="addUldOut" :disabled="isLoading"
          >Add to ULD Batch</el-button
        >
      </template>
    </app-dialog>
  </div>
</template>

<script>
import api from "@/api";
import moment from "moment";
import ULD from "@/models/ULD";
export default {
  name: "DashboardCompleted",
  data: () => ({
    isLoading: false,
    customer: "",
    status: "",
    uldType: [],
    tableData: [],
    selection: [],
    formModel: {},
    rules: {
      delivery_date: [
        {
          required: true,
          message: "Delivery Date is required.",
          trigger: "blur"
        }
      ]
    },
    uldOutList: [],
    uldOut: { id: "" },
    is_disabled: false
  }),
  computed: {
    customers() {
      return this.$store.getters["dashboard/customers"];
    },
    uldTypes() {
      return this.$store.getters["dashboard/uldTypes"];
    }
  },
  methods: {
    updateSelection(list) {
      this.selection = list;
    },
    verifySelection(row) {
      if (row.action) return true;
      return false;
    },
    getTableData() {
      this.uldOut.id = "";
      this.uldOutList = [];
      if (this.customer) {
        let customer = this.customer;
        let uldTypes = this.uldType.length ? this.uldType.toString() : "all";

        this.isLoading = true;

        ULD.uld_out_library({ customer_id: customer }).then(list => {
          this.uldOutList = list;
        });

        api
          .get(`/api/v1/dashboard/view_awaiting_status/`, {
            customer_id: customer,
            uld_type: uldTypes
          })
          .then(resp => {
            this.isLoading = false;

            this.tableData = [];
            if (resp && resp.data) {
              let info = resp.data.data.msg;
              let root = {
                label: info.customer,
                children: [],
                temp: Math.random()
              };

              for (let result of info.result) {
                let stat = {
                  label: result.description + " Total",
                  uld_id_code: result.count,
                  temp: Math.random(),
                  children: []
                };
                root.children.push(stat);
                for (let item of result.uld) {
                  stat.children.push({
                    ...item,
                    temp: Math.random(),
                    action: true,
                    deliver: false
                  });
                }
                  // stat.children.push({
                  //   label: `${result.description} Total`,
                  //   uld_id_code: result.count,
                  //   temp: Math.random()
                  // });
                  // console.log(stat.children)
              }

              root.children.push({
                label: `${info.customer} Total`,
                uld_id_code: info.total,
                temp: Math.random()
              });

              this.tableData.push(root);
            }
          });
      }
    },
    createNote() {
      this.formModel = {
        is_jettainer: 0,
        delivery_date: null
      };
      this.$refs.dialog.open();
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    save() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        let payload = {
          delivery_date: moment(this.formModel.delivery_date).format(
            "YYYY-MM-DD"
          ),
          is_jettainer: this.customer,
          uldin_id: ""
        };
        let csv = this.selection.map(o => o.id);

        this.isLoading = true;
        if (csv.length) {
          payload.uldin_id = csv;
          ULD.post_uld_out(payload).then(resp => {
            this.isLoading = false;
            this.$refs.dialog.close();

            if (resp) {
              this.$notify({
                position: "bottom-right",
                message: "Done saving ULD Out.",
                type: "success"
              });

              window.open(`/print/repair-uld-out/${resp.data.id}`);
            }
            this.getTableData();
            this.formModel = {};
            this.$store.dispatch("dashboard/getCustomers");
            this.$store.dispatch("dashboard/jo_status");
          });
        }
      });
    },
    addToBatch() {
      this.uldOut.id = "";
      this.$refs.addToUld.open();
    },
    addUldOut() {
      if (this.uldOut.id) {
        let payload = {
          uldin_id: "",
          batchid: this.uldOut.id,
          is_jettainer: this.customer
        };
        let csv = this.selection.map(o => o.id);
        payload.uldin_id = csv;
        this.isLoading = true;
        ULD.batch_update(payload).then(resp => {
          if (resp.code == 200) {
            this.$notify({
              message: "Selected job orders are added to the ULD Out",
              type: "success",
              position: "bottom"
            });
            this.$refs.addToUld.close();
            this.getTableData();
          } else {
            this.$notify({
              message: "Adding job orders failed.",
              type: "error",
              position: "bottom"
            });
          }
          this.isLoading = false;
        });
      } else {
        this.$notify({
          message: "ULD Out is required.",
          position: "bottom-right",
          type: "error"
        });
      }
    }
  },
  mounted() {
    this.$store.dispatch("dashboard/getCustomers");
    if(this.customers.length == 1) {
      this.customer = this.customers[0]['id'];
      this.getTableData();
      this.is_disabled = true;
    }

  }
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-checkbox.is-disabled {
    display: none;
  }
  th.el-table-column--selection {
    .cell::after {
      content: "Delivery?";
      display: inline-block;
    }
    .cell .el-checkbox {
      display: none;
    }
  }
}
</style>
